import React, {Component} from "react"
import {connect} from "react-redux"
import {Modal} from "react-bootstrap"
import {injectIntl} from 'react-intl'
import IBoxRow from "../../../components/IBoxRow"
import EnterpriseAccountWithLicenseForm from "./EnterpriseAccountWithLicenseForm"
import {updateEnterpriseAccount} from "../../../dispatch"
import {RxEmitter} from "rxemitter"
import {EVENT_ENTERPRISE_ACCOUNT_UPDATED} from "../../../constants"
import {alertSuccess} from "../../../util/AlertUtil"

function mapStateToProps(state, ownProps) {

  const user = state.user
  const enterpriseAccount = state.enterpriseAccount
  return {
    user,
    enterpriseAccount
  }
}

const mapDispatchToProps = {
  updateEnterpriseAccount
}

class EnterpriseAccountWithLicenseUpdateModal extends Component {

  componentWillMount() {

    const format = this.props.intl.formatMessage

    RxEmitter.on(EVENT_ENTERPRISE_ACCOUNT_UPDATED).subscribe((x)=> {
      alertSuccess(format({id:'enterprise.account.updated'}), "", ()=>{this.props.onHide(true)})
    });

    if (this.props.id)
      this.props.queryUserInfoById(this.props.id)
  }

  onSubmit = (data)=>{
    this.props.updateEnterpriseAccount(data)
  }

  render() {
    
    return (
      <Modal bsSize="lg"
             onEntered={()=>{
               this.setState({submitted: false})
             }}
             show={this.props.show} onHide={()=>{this.props.onHide(false)}}>
        <Modal.Header closeButton>
          <h2>Edit Enterprise Account</h2>
        </Modal.Header>

        <Modal.Body className="gray-bg" style={{height:480}}>

          <IBoxRow>
            <div className="row">
              <div className="col-xs-12">
                <EnterpriseAccountWithLicenseForm
                  onSubmit={this.onSubmit}
                  enterpriseAccount={this.props.enterpriseAccount}/>
              </div>
            </div>
          </IBoxRow>
        </Modal.Body>
      </Modal>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(EnterpriseAccountWithLicenseUpdateModal))



// WEBPACK FOOTER //
// ./src/routes/admin/components/EnterpriseAccountWithLicenseUpdateModal.js